import { useState, useCallback, useEffect } from 'react';
import {
  getPaperRequests,
  getCertificateRequests,
  createPaperRequest,
  createCertificateRequest,
  PaperRequest,
  CertificateRequest,
} from '../services/requestsService';

export const useRequests = () => {
  const [paperRequests, setPaperRequests] = useState<PaperRequest[]>([]);
  const [certRequests, setCertRequests] = useState<CertificateRequest[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadRequests = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [papersData, certsData] = await Promise.all([
        getPaperRequests().catch(() => ({ requests: [] })),
        getCertificateRequests().catch(() => ({ requests: [] })),
      ]);
      setPaperRequests(papersData.requests || []);
      setCertRequests(certsData.requests || []);
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Ошибка загрузки заявок');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  const handleCreatePaperRequest = useCallback(async (comment: string) => {
    try {
      const { request } = await createPaperRequest({ comment });
      setPaperRequests((prev) => [request, ...prev]);
      return { success: true };
    } catch (err: any) {
      return { success: false, error: err.response?.data?.message || err.message };
    }
  }, []);

  const handleCreateCertificateRequest = useCallback(async (description: string) => {
    try {
      const { request } = await createCertificateRequest({ description });
      setCertRequests((prev) => [request, ...prev]);
      return { success: true };
    } catch (err: any) {
      return { success: false, error: err.response?.data?.message || err.message };
    }
  }, []);

  return {
    paperRequests,
    certRequests,
    isLoading,
    error,
    refetch: loadRequests,
    handleCreatePaperRequest,
    handleCreateCertificateRequest,
  };
};
